export const ACTIONS_DROPDOWN_PROPS = {
  trigger: ["click"],
  placement: "bottomRight",
  autoAdjustOverflow: true,
  getPopupContainer: () => document.body,
  overlayClassName: "actions-dropdown-overlay",
};